import { useState } from 'react'
import { useApartmentsUnderZoneHead } from '../../assets/api/useAdminApi'
import { DataGrid } from '@mui/x-data-grid'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton'
import CustomPagination from '../../shared/utils/CustomPagination'
import { Typography } from '@mui/material'

export const ApartmentListUnderZoneHead = ({ id }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 5 });
    const { data: apartmentList, isLoading } = useApartmentsUnderZoneHead({ user_id: id })
    const apartmentRow = apartmentList?.apartments?.map((item, index) => ({
        sr_no: index + 1,
        id: index + 1,
        ...item
    })) || []
    const apartmentColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "cluster_name",
            headerName: "Cluster Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "zone_name",
            headerName: "Zone Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "city_name",
            headerName: "City Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "state_name",
            headerName: "State Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "country_name",
            headerName: "Country Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },


    ]

    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={apartmentRow}
                    columns={apartmentColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={apartmentRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}
